import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import configData from "../config";
import { axiosSetting, showToast } from "../libs/utils";
import { useAppContext } from "../libs/contextLib";
import { PageLayout } from "../components/PageLayout";

export const MainLayout = () => {
  const navigate = useNavigate();
  const search = useLocation().pathname;

  const pathStr = search.replace("/", "");

  const { configureData } = useAppContext();
  const dealerId = configureData?.id || "";
  let offerCode = "";

  const urlPath = pathStr.split("/");
  if (urlPath && urlPath.length > 0 && urlPath[0]) {
    offerCode = urlPath[0];
  }
  const [salesData, setSalesData] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isPaymentLoading, setPaymentLoading] = useState(false);

  const onGetOfferDetail = useCallback(
    async (dealerId, code) => {
      setIsDataLoading(true);
      const axiosCall = axiosSetting(code);
      const apiUrlGetDetail = configData.getOfferDetail + "/" + dealerId;
      const offerdata = await axiosCall.get(apiUrlGetDetail);
      if (offerdata && offerdata.data && offerdata.data.data) {
        const record = offerdata.data.data;
        setIsDataLoading(false);
        setSalesData(record);
      } else {
        setIsDataLoading(false);
        navigate("/");
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (offerCode && offerCode !== "") {
      onGetOfferDetail(dealerId, offerCode);
    }
  }, [dealerId, offerCode, onGetOfferDetail]);

  // get details from offer code.

  // Refresh page with new offer code from chiild component.
  const reloadOfferCodeChild = async (code) => {
    const axiosCall = axiosSetting(code);
    const offerdata = await axiosCall.get(configData.getOfferDetail);
    if (offerdata && offerdata.data && offerdata.data.data) {
      const record = offerdata.data.data;
      if (record.is_expired) {
        showToast("error", "Sorry, entered offercode is not valid.");
      } else {
        setSalesData(record);
      }
    } else {
      showToast(
        "error",
        "Sorry, entered offercode is not valid, data not found."
      );
    }
  };

  return (
    <>
      {isDataLoading && (
        <div id="loaderPar">
          {" "}
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100vh" }}
          >
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        </div>
      )}

      {isPaymentLoading && (
        <div id="loaderPar">
          {" "}
          <div id="loader"></div>{" "}
          <div className="loader-text">
            <div>We are processing your payment.</div>
            <div className="loading-text">
              <span>&nbsp;P</span>
              <span>l</span>
              <span>e</span>
              <span>a</span>
              <span>s</span>
              <span>e&nbsp;</span>
              <span>W</span>
              <span>a</span>
              <span>i</span>
              <span>t</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          </div>
        </div>
      )}

      <div className="pagewrpaper">
        <PageLayout
          salesData={salesData}
          setSalesData={setSalesData}
          setPaymentLoading={setPaymentLoading}
          offerCode={offerCode}
          reloadOfferCode={reloadOfferCodeChild}
          isDataLoading={isDataLoading}
          setIsDataLoading={setIsDataLoading}
        />
      </div>
    </>
  );
};
